<template lang="pug">
    .settings-page.settings-reviews
        settings-page-head
        .settings-page__body
            .text-right.mb-4.settings-reviews-menu(v-if="authUser.game_master")
                .btn(@click="page = 1, showReviews = true" :class="{ 'btn-primary': showReviews }") Reviews
                .btn(@click="page = 1, showReviews = false" :class="{ 'btn-primary': !showReviews }") My Reviews
            .scrollable-table
                table.table.table-borderless.table-striped.settings-table.settings-table
                    thead
                        th Review
                        th
                            template(v-if="showReviews") Submitted By
                            template(v-else) Game Master
                        th Publish Date
                    tbody
                        tr(v-for="review in tableData")
                            td.review-container
                                .review-rating
                                    rating-stars(:rating="review.rating" all)
                                .review-message {{ review.message }}
                            td
                                template(v-if="showReviews") {{ review.user.data.name }}
                                template(v-else) {{ review.product.data.user.data.name }}
                            td
                                time(:datetime="review.reviewed_at") {{ moment(review.reviewed_at).format('MMM D, h:mm A') }}

            settings-table-paging(v-if="pages > 1" :page="page" :pages="pages" @click="page = $event.page")

</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

const PAGE_SIZE = 7

export default {
    name: 'settings-reviews',

    data() { return {
        showReviews: false,
        reviews: [],
        myReviews: [],
        page: 1,
    }},

    computed: {
        ...mapGetters(['authUser']),

        pages() {
            const items = this.showReviews ? this.reviews.length : this.myReviews.length
            return Math.floor((items - 1) / PAGE_SIZE + 1)
        },

        tableData() {
            const items = this.showReviews ? this.reviews : this.myReviews
            return items.slice(PAGE_SIZE * (this.page - 1), PAGE_SIZE * this.page)
        },
    },

    async created() {
        if (this.authUser.game_master) {
            this.showReviews = true
            const { data: { data: reviews } } = await axios.get(`/api/customer/game-master-reservation-product/${this.authUser.product.data.id}/review?include=user&order=id:desc`)
            this.reviews = reviews
        }

        const { data: { data: myReviews } } = await axios.get('/api/customer/game-master-reservation-product/my-review?include=product.user&order=id:desc')
        this.myReviews = myReviews
    },

    methods: {
        moment,
    }
}
</script>
